import React, { Component } from 'react';
import {SCROLL_TIME} from 'common/js/params';
import './index.styl';

class Tablec extends Component{
    animateId;

    animating = false;

    scrollpx = 0;

    constructor(props){
        super(props);
        this.scroll = React.createRef();
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.animateId);
    }

    getHeaderDom = () => (this.props.columns || []).map((c) => (
        <span key={c.key}>{c.name}</span>
    ));

    getBodyDom = () => {
        const {data = [], filter} = this.props;
        let dealedData = data;
        if (typeof filter === 'function') {
            dealedData = filter(data);
        }
        return dealedData.map((d, i) => (
            <p key={i}>
                {(this.props.columns || []).map((c) =>(
                    <span key={`${c.key}${i}`}>
                        {typeof c.render === 'function'
                        ? c.render(d[c.key], d, c.key, i)
                        : d[c.key]}
                    </span>
                ))}
            </p>
        ));
    }

    checkScroll = () => {
        const {autoScroll} = this.props;
        if (!this.scroll.current) {
            this.animating = false;
            return false;
        }
        if (this.scroll.current.scrollHeight <= this.scroll.current.clientHeight) {
            this.animating = false;
            return false;
        }
        if (autoScroll && !this.animating) {
            this.animating = true;
            this.animateId = requestAnimationFrame(this.scrollAnimate);
        } else if (!autoScroll && this.animating) {
            this.animating = false;
            cancelAnimationFrame(this.animateId);
        }
        return true;
    }

    scrollAnimate = (time) => {
        if (!this.start) {
            this.start = time;
        }
        const diff = time - this.start;
        this.start = time;

        this.scrollpx += diff / SCROLL_TIME;
        const remainH = this.scroll.current.scrollHeight - this.scroll.current.clientHeight + 10;
        if (this.scrollpx >= remainH) {
            this.scrollpx = 0;
            // this.scroll.current.scrollTo(0, 0);
            this.scroll.current.scrollTop = 0;
        } else {
            // this.scroll.current.scrollTo(0, this.scrollpx);
            this.scroll.current.scrollTop = this.scrollpx;
        }
        this.animateId = requestAnimationFrame(this.scrollAnimate);
    }

    render() {
        const realScroll = this.checkScroll();
        const {className, styleType} = this.props;
        const clz = [];
        if (className) {
            clz.push(className);
        }
        if (styleType) {
            clz.push(styleType);
        }
        return <section className={`ssfe-table ${clz.join(' ') || ''}`}>
            <header>
                {this.getHeaderDom()}
            </header>
            <div ref={this.scroll} style={{overflow: realScroll ? 'hidden' : 'auto'}}>
                {this.getBodyDom()}
            </div>
        </section>
    }
}

//props: {className, styleType, autoScroll, data, column, filter}
export default Tablec;
